<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfaceSectionsStore } from '@@/pinia/surface_sections'
import { computed } from 'vue'
import { useSlideshowStyles } from '@@/vuecomposables/slideshow_styles'

const props = defineProps<{
  sectionId: number
}>()

const { accentColorStyle, primaryColorStyle, textColorClass } = useSlideshowStyles()
const { isCustomBackground, dir } = storeToRefs(useSurfaceStore())
const surfaceSectionsStore = useSurfaceSectionsStore()
const { getSectionById } = surfaceSectionsStore
const currentSection = computed(() => getSectionById(props.sectionId))
</script>

<template>
  <div v-if="currentSection" :class="'h-full'" :style="{ backgroundColor: primaryColorStyle }">
    <div
      :class="[
        'box-border',
        'h-full',
        'relative',
        'flex justify-center items-center tablet-landscape:justify-start tablet-landscape:items-end',
        'px-8 pb-18 pt-24',
        'tablet-portrait:p-24',
        'tablet-landscape:p-24 tablet-landscape:ps-10',
        'tablet-landscape:p-32 desktop:ps-16',
        'desktop-2xl:p-48 desktop-2xl:ps-24 desktop-2xl:pe-96',
        'desktop-3xl:p-60 desktop-3xl:ps-30 desktop-3xl:pe-120',
      ]"
    >
      <!-- Corner triangle -->
      <!-- Reference: https://stackoverflow.com/a/48962278/5870000 -->
      <div
        :class="[
          'end-0 absolute top-0',
          'h-0 w-0',
          'border-solid border-transparent',
          'border-b-64 tablet-portrait:border-b-112 desktop-2xl:border-b-212',
          'border-r-64 tablet-portrait:border-r-112 desktop-2xl:border-r-212',
          isCustomBackground && 'border-r-light-text-200',
        ]"
        :style="{
          'border-right-color': accentColorStyle,
          transform: dir === 'rtl' ? 'scale(-1,1)' : undefined, //  (top right corner for ltr, top left corner for rtl)
        }"
      />
      <h1
        :class="[
          'font-semibold',
          'text-slideshow-title-sm tablet-portrait:text-slideshow-title-md desktop:text-slideshow-title-lg desktop-2xl:text-slideshow-title-xl desktop-3xl:text-slideshow-title-2xl',
          'text-center tablet-landscape:text-start',
          'break-word-anywhere',
          textColorClass,
        ]"
        :data-testid="'slideshowPageSectionTitle'"
      >
        {{ currentSection.title }}
      </h1>
    </div>
  </div>
</template>
